import React from 'react';
import { Link } from 'react-router-dom';
// PATH CORRECT KARA: Footer kadhun Header liha
import SubPageHeader from '../../../components/common/SubPageHeader'; 

const DesignStudent = () => {
  return (
    <div className="min-h-screen bg-white">
      {/* Ata ithe barober Header render hoil */}
      <SubPageHeader title="DESIGN24: STUDENT" />
      
      <div className="py-10 md:py-20 px-4 md:px-6">
        <div className="max-w-5xl mx-auto border-4  md:border-[8px] border-[#003366]  rounded-2xl  md:rounded-[40px] shadow-2xl p-5 sm:p-8 md:p-16">
          <div className="space-y-4 md:space-y-6 text-[#1a1a1a]  md:text-[17px] leading-7  md:leading-relaxed font-medium">
            <p>Congratulations! Dear champion you are blessed to pursue education which many students of your age are deprived in the world.</p>
            <p>But only studies is boring and monotonous. You have to eventually evolve as an all-rounder. Every student like you in this world has 24 hours in day to fulfill all their dreams.</p>
            <p>It is the meticulous planning of every second of these 24 hours of a day that decides your success or failure.</p>
            <p>This course of <span className="font-bold">DESIGN24</span> endeavours to help you plan your every second to achieve your desired goals in life.</p>
            <p className="font-bold">DESIGN24 teaches you to finalise your goals.</p>
            <p>The course helps you find your passion. The tools and techniques you learn in this course will be helpful to you for lifetime to face any situation.</p>
            <p>We have seen a rise of marks from <span className="font-bold">10% to 25%</span> in students who sincerely followed the guidelines in the DESIGN24 COURSE. You learn to study and gain more marks in less time.</p>
            <p>The planning tools, decision making tools, passion finding techniques will always be your support and guardian in any field you choose.</p>
            <p>Self-motivation is the key to success. Unless you yourself decide to achieve something, nothing can be done.</p>
            <p>This course motivates you to live a life of your choice. Perform chores of your passion and teach you the techniques to convince your parents in a way they can understand.</p>
            <p>Apart from the rise in your marks the main thing you gain by doing DESIGN24 course is <span className="font-bold underline italic">SELF-CONFIDENCE</span>.</p>
            <p>You know what you want in life. You become focussed. This relieves you and parents from frustration and ambiguity regarding your career and capabilities. The ultimate goal is to always keep your <span className="font-bold"> HAPPINESS INDEX</span> at the peak!</p>
          </div>

          <div className="mt-12 text-center space-y-6">
            <p className="text-[#003366] font-bold  text-base sm:text-lg  md:text-xl uppercase tracking-wide  text-center  leading-relaxed">
              REGISTER AND SIGNUP FOR DESIGN24- for a BRIGHT & CONFIDENT FUTURE! <br />
              JOIN THE HAPPINESS FAMILY!
            </p>
            <div className="pt-4">
              <Link to="/TGSH/login" className="inline-block w-full sm:w-auto bg-[#003366] text-white px-8 md:px-10 py-3 rounded-full font-bold uppercase tracking-wide hover:bg-[#005f8d]  transition-all shadow-lg active:scale-95">
                Login To Continue
              </Link>
            </div>
          </div>
        </div>
      </div>
      
      
    </div>
  );
};

export default DesignStudent;